import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-Medal',
  standalone: true,
  templateUrl: '../../assets/Medal.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamMedalIcon {}
